import * as React from "react"
const ReportsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={22}
    height={22}
    fillRule="evenodd"
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#fff"
      d="M29.074 11v16a3 3 0 0 1-3 3H10.068a3 3 0 0 1-3.001-3v-7.132a8.53 8.53 0 0 0 1.5.132c4.693 0 8.503-3.809 8.503-8.5S13.26 3 8.568 3c-.258 0-.514.012-.766.034A2.996 2.996 0 0 1 10.07 2h10.003v6a3 3 0 0 0 3 3zM13.07 25v-1a1 1 0 0 0-2 0v1a1 1 0 0 0 2 0zm4.002 0v-4a1 1 0 0 0-2 0v4a1 1 0 0 0 2 0zm4 0v-3a1 1 0 0 0-2 0v3a1 1 0 0 0 2 0zm4.002 0v-7a1 1 0 0 0-2 0v7a1 1 0 0 0 2 0zm-3-22.981a3.002 3.002 0 0 1 1.88.963l4.341 4.773c.324.358.556.785.679 1.245h-5.9a.997.997 0 0 1-1-1zM14.992 12.5A6.506 6.506 0 0 1 8.568 18a6.505 6.505 0 0 1-6.502-6.5 6.506 6.506 0 0 1 5.502-6.423V10.5a2 2 0 0 0 2 2zM9.568 5.077a6.509 6.509 0 0 1 5.425 5.423H9.568z"
      data-original="#000000"
    />
  </svg>
)

export default ReportsIcon
